import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isOwner, setIsOwner] = useState(false);

  const loginAsOwner = () => {
    setIsOwner(true);
  };

  const logout = () => {
    setIsOwner(false);
  };

  return (
    <AuthContext.Provider value={{ isOwner, loginAsOwner, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
